export default {
	subtitle: "",
	path: "webhooks_subscription_canceled",
	paragraphs: [
		"This webhook is triggered whenever a subscription is canceled, either by the merchant via API or by the payer. The field `canceled_by_payer` indicates whether the cancellation was initiated by the payer (`true`) or by the merchant (`false`).",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"secret": "the value you received",
						"type": "subscription_canceled",
						"subscription": {
							"canceled_by_payer": false,
							"canceled_reason": "some reason",
							"id": "7de0dc6f-f514-4401-84f3-ff19183e6b92",
							"status": "canceled",
							"subject_id": "76d5aea7-f532-47be-9cfb-b1f615c7bc84"
						},
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationSubscriptionCanceled.js